import { createUseStyles } from 'react-jss'

export const style = {
  content: {
    composes: 'report-text-block-width'
  },
  toolbar: {
    position: 'sticky',
    top: 0,
    zIndex: 1
  }
}

export const useStyles = createUseStyles(style)
